var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition-group",
    {
      staticClass:
        "fixed inset-0 z-100 flex flex-col px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-start sm:top-16 items-start justify-start",
      attrs: { name: "alert-list", tag: "div" },
    },
    _vm._l(_vm.items, function (n, i) {
      return _c("notification", {
        key: i.toString(),
        attrs: { status: n.status, title: n.title, message: n.message },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }